<template>
  <header class="admin-header">
    <div
      v-if="breadcrumbName && breadcrumbName !== 'Home'"
      class="admin-header-inner"
    >
      <div v-if="$vuetify.breakpoint.xsOnly">
        <img
          width="28px"
          height="28px"
          src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1662449121050.svg"
          @click="back"
        />
      </div>
      <Breadcrumb class="mobile-header" :name.sync="breadcrumbName" />
      <div class="mr-2">
        <div class="profile-menu ml-auto">
          <ul>
            <li class="my-profile">
              <v-layout v-if="user && user.firstName" justify-end wrap>
                <v-avatar
                  v-if="user.media && user.media.length && user.media[0].url"
                  class="profile-v-avatar"
                  color="#344452"
                >
                  <img :src="user.media[0].url" />
                </v-avatar>
                <v-avatar
                  v-else
                  class="profile-v-avatar user-avatar"
                  color="#344452"
                >
                  <span class="user-text">{{ user | initial }}</span>
                </v-avatar>
                <strong>
                  {{ user.firstName + " " + user.lastName }},
                  {{ roleName }}
                </strong>
              </v-layout>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <v-row
      v-if="!breadcrumbName || breadcrumbName === 'Home'"
      class="home-header"
    >
      <v-col cols="2">
        <v-list-item class="avtar-cls pl-0">
          <v-list-item-avatar color="#F0F0F0" size="56px" class="user-avatar">
            <v-img
              v-if="user.media && user.media.length && user.media[0].url"
              :src="user.media[0].url"
            />
            <span v-else class="display-2 user-text">{{ user | initial }}</span>
          </v-list-item-avatar>
        </v-list-item>
      </v-col>
      <v-col class="ml-4">
        <p class="mt-3 profile-name-section">
          {{ user.firstName }} {{ user.lastName }}, {{ user.title }}
        </p>
        <p class="profile-text">
          {{ roleName }}
        </p>
      </v-col>
    </v-row>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { AuthMixin } from "@/mixins";
export default {
  name: "Header",
  components: {
    Breadcrumb: () => import("@/components/BreadCrumb")
  },
  mixins: [AuthMixin],
  data() {
    return {
      dialog: false,
      breadcrumbName: ""
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "user"
    }),
    roleName() {
      return this.user.roles ? this.user.roles.name : this.user.roleName;
    }
  },
  watch: {
    $route() {
      this.breadcrumbName = this.$route.meta.module;
    }
  },
  created() {
    this.breadcrumbName = this.$route.meta.module;
  },
  mounted() {
    const jQuery = require("jquery");
    jQuery(document).ready(() => {
      jQuery(".my-profile a").click(function() {
        jQuery(this)
          .next()
          .toggleClass("hide");
      });
    });
  },
  methods: {
    emitEvent() {
      const index = 1;
      this.$bus.$emit("setActiveId", index);
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.justify-space-around {
  strong {
    margin-top: 6px;
    margin-left: 10px;
  }
}
.profile-v-avatar {
  height: 40px !important;
  width: 40px !important;
  min-width: 40px !important;
  border: 1px solid #d6e0ef;
}
.user-avatar {
  border: 1px solid #d6e0ef !important;
  border-radius: 50% !important;
  background-color: #fcfcfc !important;
}
.user-text {
  font-size: 28px !important;
  color: #000 !important;
  caret-color: #000 !important;
}
</style>
